<template>
  <div>
    <div id="save-supplement-success" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-9" />
      <div class="ml-4 mr-4">
        <div class="font-medium">{{ $t("views.supplements.text9") }}</div>
        <div class="text-gray-600 mt-1"></div>
      </div>
    </div>
    <!-- Suplemento: nombre comercial -->
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">
        {{ $t("views.perfil_marca.text2") }}: {{ product.brand }} , {{ $t("views.productos.text3") }}:
        {{ product.substance }}
      </h2>
    </div>
    <div class="grid grid-cols-1 gap-6 mt-5 mb-12">
      <div class="intro-y col-span-12 lg:col-span-6">
        <div class="lang__tabs nav nav-tabs flex-col sm:flex-row text-gray-600 rounded-b-none" role="tablist">
          <a
            v-for="(lang, key) in langs"
            :key="key"
            data-toggle="tab"
            @click="changeLang('lang__' + lang.key)"
            :data-target="'#lang__' + lang.key"
            href="javascript:;"
            class="tooltip w-full sm:w-40 py-4 text-center flex justify-center items-center rounded-t-md"
            :class="activeLang === 'lang__' + lang.key ? 'active' : ''"
            :id="'lang__' + lang.key + '-tab'"
            role="tab"
            :aria-controls="'lang__' + lang.key"
            aria-selected="false"
          >
            {{ $t("components.langs." + lang.key + ".name") }}
          </a>
        </div>
        <div v-for="(lang, key) in langs" :key="key" :class="'post__lang__' + lang.key" class="tab-content">
          <div
            :id="'lang__' + lang.key"
            class="tab-pane"
            :class="activeLang === 'lang__' + lang.key ? 'active' : ''"
            role="tabpanel"
            :aria-labelledby="'lang__' + lang.key + '-tab'"
          >
            <!-- BEGIN: Form Layout -->
            <!-- Marca: nombre , tipo de sustancia : sustancia -->
            <div class="intro-y box p-5">
              <!-- campo de marca, tags -->
              <div class="mt-3">
                <label for="crud-form-3" class="form-label">{{ $t("views.perfil_marca.text2") }}</label>
                <div class="input-group">
                  <TomSelect
                    ref="brands"
                    class="w-full cursor"
                    v-model="product.brand"
                    :max="5"
                    :placeholder="$t('views.supplements.text48')"
                    :plugins="['dropdown_input']"
                  >
                    <option value="">{{ $t("views.supplements.text48") }}</option>
                    <option v-for="(brand, key) in brands" :key="key" :value="brand.id">
                      {{ brand.name }}
                    </option>
                  </TomSelect>
                </div>
                <div v-if="validations.brand" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.text11") }}
                </div>
              </div>
              <!-- campo de tipo de sustancias -->
              <div class="mt-3">
                <label for="crud-form-3" class="form-label">{{ $t("views.productos.text13") }}</label>
                <div class="input-group">
                  <TomSelect
                    ref="substance"
                    class="w-full cursor"
                    v-model="product.substance"
                    :placeholder="$t('views.supplements.text48')"
                    :input_hide="true"
                  >
                    <option value="">{{ $t("views.supplements.text48") }}</option>
                    <option v-for="(substance, key) in substances" :key="key" :value="substance.id">
                      {{ substance.name }}
                    </option>
                  </TomSelect>
                </div>
                <div v-if="validations[`article_${key}`]?.substance" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.text11") }}
                </div>
              </div>
              <!--seccion listado de productos -->
              <div class="mt-3">
                <label for="crud-form-3" class="form-label font-semibold">{{ $t("views.productos.text5") }}</label>
                <div class="grid gap-6">
                  <div
                    v-for="(article, articleIndex) in product.articles"
                    class="border-custom-gray-8 border-1 rounded-lg p-6"
                    :key="articleIndex"
                  >
                    <!-- boton para eliminar -->
                    <div class="w-auto pr-2 flex justify-end items-start mt-2">
                      <button
                        v-on:click="removeArticulo(articleIndex)"
                        type="button"
                        class="btn-outline-dark p-0 btn-rounded btn-md remove-item"
                      >
                        <XCircleIcon class="btn-source-icon w-6 h-6" />
                      </button>
                    </div>
                    <!-- campo producto: con numeracions -->
                    <div class="input-group gap-5">
                      <h2 class="form-label font-semibold text-base">
                        {{ $t("views.productos.text4") }} : {{ article.langs[lang_key].nameTicket }}
                      </h2>
                    </div>
                    <div class="intro-y flex items-center mt-4">
                      <h2 class="text-md font-medium mr-auto">
                        {{ $t("views.productos.text29") }} :
                        {{ $t(`views.typesComponents.${article.componentsGroups}`) }}
                      </h2>
                    </div>

                    <!-- campo de sustancias, tags -->
                    <div class="mt-3">
                      <label for="crud-form-3" class="form-label">{{ $t("views.productos.text3") }}</label>
                      <div class="input-group">
                        <TomSelect
                          ref="substances"
                          class="w-full cursor"
                          v-model="article.substances"
                          :placeholder="$t('views.productos.text14')"
                          :plugins="['dropdown_input']"
                          @change="calculatedComponentsGroups(key)"
                        >
                          <option value="">{{ $t("views.supplements.text48") }}</option>
                          <option v-for="(substance, key) in substances" :key="key" :value="substance.id">
                            {{ substance.name }}
                          </option>
                        </TomSelect>
                      </div>
                      <div v-if="validations[`article_${key}`]?.substances" class="text-theme-6 mt-2">
                        {{ $t("views.supplements.text11") }}
                      </div>
                    </div>

                    <!-- campo de nombre del ticker-->
                    <div class="w-full">
                      <div class="mt-4">
                        <label for="crud-form-13" class="form-label">{{ $t("views.productos.text7") }} </label>
                        <div class="input-group">
                          <input
                            id="crud-form-13"
                            type="text"
                            name="chart-tooltip"
                            class="form-control w-full"
                            :placeholder="$t('views.productos.text7')"
                            v-model="article.langs[lang_key].nameTicket"
                            :key="lang_key"
                          />
                        </div>
                        <div v-if="validations[`article_${key}`]?.langs" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text95") }}
                        </div>
                      </div>
                    </div>

                    <!-- seccion components -->
                    <div class="mt-4">
                      <div class="grid gap-6">
                        <div
                          v-for="(component, componentIndex) in article.components"
                          class="border-custom-gray-8 border-1 rounded-lg p-4"
                          :key="componentIndex"
                        >
                          <div class="flex flex-col sm:flex-row items-center gap-6">
                            <!-- Componente activo -->
                            <div class="flex flex-col sm:flex-row items-center gap-2">
                              <div class="w-full">
                                <div class="mt-4">
                                  <label for="crud-form-componente" class="form-label">
                                    {{ $t("views.productos.text32") }}
                                  </label>
                                  <div class="input-group">
                                    <input
                                      id="crud-form-componente"
                                      type="text"
                                      name="component"
                                      class="form-control w-full"
                                      :placeholder="$t('views.productos.text32')"
                                      v-model="component.componentActive"
                                    />
                                  </div>
                                  <div
                                    v-if="
                                      validations.articles[articleIndex]?.components?.[componentIndex]?.componentActive
                                    "
                                    class="text-theme-6 mt-2"
                                  >
                                    {{ $t("views.supplements.text11") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- cantidad por servicio -->
                            <div class="flex flex-col sm:flex-row items-center gap-2">
                              <div class="w-full">
                                <div class="mt-4">
                                  <label for="crud-form-amountserving" class="form-label">
                                    {{ $t("views.productos.text33") }}
                                  </label>
                                  <div class="input-group">
                                    <input
                                      id="crud-form-amountserving"
                                      type="number"
                                      name="expiration"
                                      class="form-control w-full"
                                      :placeholder="$t('views.productos.text33')"
                                      v-model="component.amountPerServing"
                                    />
                                  </div>
                                  <div
                                    v-if="
                                      validations.articles[articleIndex]?.components?.[componentIndex]?.amountPerServing
                                    "
                                    class="text-theme-6 mt-2"
                                  >
                                    {{ $t("views.supplements.text11") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- dv -->
                            <div class="flex flex-col sm:flex-row items-center gap-2">
                              <div class="w-full">
                                <div class="mt-4">
                                  <label for="crud-form-dv" class="form-label">
                                    {{ $t("views.productos.text34") }}
                                  </label>
                                  <div class="input-group">
                                    <input
                                      id="crud-form-dv"
                                      type="number"
                                      name="price"
                                      class="form-control w-full"
                                      :placeholder="$t('views.productos.text34')"
                                      v-model="component.dv"
                                    />
                                  </div>
                                  <div
                                    v-if="validations.articles[articleIndex]?.components?.[componentIndex]?.dv"
                                    class="text-theme-6 mt-2"
                                  >
                                    {{ $t("views.supplements.text11") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Botón para eliminar component -->
                            <button
                              @click="removeComponent(articleIndex, componentIndex)"
                              type="button"
                              class="btn-outline-dark p-0 btn-rounded btn-md remove-item ml-auto"
                            >
                              <XCircleIcon class="btn-source-icon w-6 h-6" />
                            </button>
                          </div>

                          <!-- Botón para agregar componente -->
                          <div class="mt-4">
                            <button @click="addComponent(key)" type="button" class="btn btn-primary">
                              {{ $t("views.productos.text35") }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- campo de formatos, tags -->
                    <div class="mt-3">
                      <label for="crud-form-3" class="form-label">{{ $t("views.supplements.text52") }}</label>
                      <div class="input-group">
                        <TomSelect
                          ref="formats"
                          class="w-full cursor"
                          v-model="article.format"
                          :placeholder="$t('views.supplements.text48')"
                          :input_hide="true"
                        >
                          <option value="">{{ $t("views.supplements.text48") }}</option>
                          <option v-for="(format, key) in formats" :key="key" :value="format.id">
                            {{ format.name }}
                          </option>
                        </TomSelect>
                      </div>
                      <div v-if="validations.formats" class="text-theme-6 mt-2">
                        {{ $t("views.supplements.text11") }}
                      </div>
                    </div>

                    <!-- campo de fuente natural -->
                    <div class="mt-3">
                      <div class="w-full">
                        <label for="crud-form-3" class="form-label">{{ $t("views.supplements.text53") }}</label>
                        <div class="input-group">
                          <TomSelect
                            ref="naturalSources"
                            class="w-full cursor"
                            v-model="article.naturalSource"
                            :placeholder="$t('views.supplements.text30')"
                            :input_hide="true"
                          >
                            <option value="">{{ $t("views.supplements.text30") }}</option>
                            <option v-for="(option, key) in naturalSources" :key="key" :value="option">
                              {{ $t("views.natural_source." + option) }}
                            </option>
                          </TomSelect>
                        </div>
                      </div>
                      <div v-if="validations.natural_source" class="text-theme-6 mt-2">
                        {{ $t("views.supplements.text11") }}
                      </div>
                    </div>

                    <!-- SUPLEMENT FACTS -->
                    <div class="flex flex-col sm:flex-row items-center gap-6">
                      <!-- dias de suminitro -->
                      <h2 class="form-label font-semibold text-base">
                        {{ $t("views.productos.text12") }} : {{ article.supplementFacts.supplyDays }}
                      </h2>
                      <!-- por servicio -->
                      <div class="flex flex-col sm:flex-row items-center gap-2">
                        <div class="w-full">
                          <div class="mt-4">
                            <label for="crud-form-1" class="form-label">
                              {{ $t("views.productos.text10") }}
                            </label>
                            <div class="input-group">
                              <input
                                id="crud-form-1"
                                type="number"
                                name="perServing"
                                class="form-control w-full"
                                :placeholder="$t('views.productos.text10')"
                                v-model="article.supplementFacts.perServing"
                                @input="supplyDays(article)"
                                min="0"
                                max="10"
                              />
                            </div>
                            <div v-if="validations.perServing" class="text-theme-6 mt-2">
                              {{ $t("views.supplements.text11") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- por envase -->
                      <div class="flex flex-col sm:flex-row items-center gap-2">
                        <div class="w-full">
                          <div class="mt-4">
                            <label for="crud-form-1" class="form-label">
                              {{ $t("views.productos.text11") }}
                            </label>
                            <div class="input-group">
                              <input
                                id="crud-form-1"
                                type="number"
                                name="bd"
                                class="form-control w-full"
                                :placeholder="$t('views.productos.text11')"
                                v-model="article.supplementFacts.perComponent"
                                @input="supplyDays(article)"
                              />
                            </div>
                            <div v-if="validations.perComponent" class="text-theme-6 mt-2">
                              {{ $t("views.supplements.text11") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- campo de certificacion, tags -->
                    <div class="mt-4">
                      <label for="crud-form-3" class="form-label">{{ $t("views.productos.text15") }}</label>
                      <div class="input-group">
                        <TomSelect
                          ref="certification"
                          class="w-full cursor"
                          v-model="article.certifications"
                          :max="5"
                          :placeholder="$t('views.supplements.text48')"
                          :plugins="['dropdown_input']"
                        >
                          <option value="">{{ $t("views.productos.text16") }}</option>
                          <option
                            v-for="(certifications, key) in certificationsProduct"
                            :key="key"
                            :value="certifications.id"
                          >
                            {{ certifications.name }}
                          </option>
                        </TomSelect>
                      </div>
                      <div v-if="validations.certification" class="text-theme-6 mt-2">
                        {{ $t("views.supplements.text11") }}
                      </div>
                    </div>

                    <!-- campo de etiquetas, tags -->
                    <div class="mt-4">
                      <label for="crud-form-3" class="form-label">{{ $t("views.productos.text17") }}</label>
                      <div class="input-group">
                        <TomSelect
                          ref="labels"
                          class="w-full cursor"
                          v-model="article.labels"
                          :max="5"
                          :placeholder="$t('views.supplements.text48')"
                          :plugins="['dropdown_input']"
                        >
                          <option value="">{{ $t("views.productos.text18") }}</option>
                          <option v-for="(labels, key) in labelsProduct" :key="key" :value="labels.id">
                            {{ labels.name }}
                          </option>
                        </TomSelect>
                      </div>
                      <div v-if="validations.labels" class="text-theme-6 mt-2">
                        {{ $t("views.supplements.text11") }}
                      </div>
                    </div>

                    <!-- campo de  uso del de la producto-->
                    <div class="mt-4">
                      <label for="crud-form-3" class="form-label">{{ $t("views.productos.text21") }}</label>
                      <div class="input-group">
                        <textarea
                          id="crud-form-3"
                          type="text"
                          class="form-control"
                          :placeholder="$t('views.productos.text21')"
                          aria-describedby="input-group-1"
                          rows="6"
                          v-model="article.langs[lang_key].used"
                          maxlength="300"
                        />
                      </div>
                      <div v-if="validations[`article_${key}`]?.langs" class="text-theme-6 mt-2">
                        {{ $t("views.perfil_marca.text17") }}
                      </div>
                    </div>
                    <!-- campo de advertencias del de la producto-->
                    <div class="mt-4">
                      <label for="crud-form-3" class="form-label">{{ $t("views.productos.text22") }}</label>
                      <div class="input-group">
                        <textarea
                          id="crud-form-3"
                          type="text"
                          class="form-control"
                          :placeholder="$t('views.productos.text22')"
                          aria-describedby="input-group-1"
                          rows="6"
                          v-model="article.langs[lang_key].warning"
                          maxlength="300"
                        />
                      </div>
                      <div v-if="validations[`article_${key}`]?.langs" class="text-theme-6 mt-2">
                        {{ $t("views.perfil_marca.text17") }}
                      </div>
                    </div>

                    <!-- campo de monedas, tags -->
                    <div class="mt-4">
                      <label for="crud-form-3" class="form-label">{{ $t("views.productos.text25") }}</label>
                      <div class="input-group">
                        <TomSelect
                          ref="currency"
                          class="w-full cursor"
                          v-model="article.currency"
                          :max="5"
                          :placeholder="$t('views.supplements.text48')"
                          :plugins="['dropdown_input']"
                        >
                          <option value="">{{ $t("views.productos.text25") }}</option>
                          <option v-for="(currency, key) in currencies" :key="key" :value="currency.id">
                            {{ currency.name }}
                          </option>
                        </TomSelect>
                      </div>
                      <div v-if="validations.currency" class="text-theme-6 mt-2">
                        {{ $t("views.supplements.text11") }}
                      </div>
                    </div>

                    <!-- seccion stocks -->
                    <div class="mt-4">
                      <div class="grid gap-6">
                        <div
                          v-for="(stock, stockIndex) in article.stocks"
                          class="border-custom-gray-8 border-1 rounded-lg p-4"
                          :key="stockIndex"
                        >
                          <div class="flex flex-col sm:flex-row items-center gap-6">
                            <!-- disponibilidad de stock -->
                            <div class="flex flex-col sm:flex-row items-center gap-2">
                              <div class="w-full">
                                <div class="mt-4">
                                  <label for="crud-form-stockA" class="form-label">
                                    {{ $t("views.productos.text26") }}
                                  </label>
                                  <div class="input-group">
                                    <input
                                      id="crud-form-stockA"
                                      type="number"
                                      name="stock"
                                      class="form-control w-full"
                                      :placeholder="$t('views.productos.text26')"
                                      v-model="stock.stockA"
                                    />
                                  </div>
                                  <div
                                    v-if="validations.articles[articleIndex]?.stocks?.[stockIndex]?.stockA"
                                    class="text-theme-6 mt-2"
                                  >
                                    {{ $t("views.supplements.text11") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- fecha de caducidad -->
                            <div class="flex flex-col sm:flex-row items-center gap-2">
                              <div class="w-full">
                                <div class="mt-4">
                                  <label for="crud-form-expiration" class="form-label">
                                    {{ $t("views.productos.text27") }}
                                  </label>
                                  <div class="input-group">
                                    <input
                                      id="crud-form-expiration"
                                      type="date"
                                      name="expiration"
                                      class="form-control w-full"
                                      :placeholder="$t('views.productos.text27')"
                                      v-model="stock.expirationDate"
                                    />
                                  </div>
                                  <div
                                    v-if="validations.articles[articleIndex]?.stocks?.[stockIndex]?.expirationDate"
                                    class="text-theme-6 mt-2"
                                  >
                                    {{ $t("views.supplements.text11") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- precio del producto -->
                            <div class="flex flex-col sm:flex-row items-center gap-2">
                              <div class="w-full">
                                <div class="mt-4">
                                  <label for="crud-form-price" class="form-label">
                                    {{ $t("views.productos.text24") }}
                                  </label>
                                  <div class="input-group">
                                    <input
                                      id="crud-form-price"
                                      type="number"
                                      name="price"
                                      class="form-control w-full"
                                      :placeholder="$t('views.productos.text24')"
                                      v-model="stock.price"
                                    />
                                  </div>
                                  <div
                                    v-if="validations.articles[articleIndex]?.stocks?.[stockIndex]?.price"
                                    class="text-theme-6 mt-2"
                                  >
                                    {{ $t("views.supplements.text11") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Botón para eliminar stock -->
                            <button
                              @click="removeStock(articleIndex, stockIndex)"
                              type="button"
                              class="btn-outline-dark p-0 btn-rounded btn-md remove-item ml-auto"
                            >
                              <XCircleIcon class="btn-source-icon w-6 h-6" />
                            </button>
                          </div>

                          <!-- Botón para agregar stock -->
                          <div class="mt-4">
                            <button @click="addStock(key)" type="button" class="btn btn-primary">
                              {{ $t("views.productos.text30") }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sección de Other Ingredients -->
                    <!-- Other Ingredients Section -->
                    <div class="mt-3">
                      <label class="form-label">{{ $t("views.productos.text19") }}</label>
                      <div
                        v-for="(ingredient, index) in article.langs[lang_key].otherIngredients"
                        :key="index"
                        class="mt-5"
                      >
                        <div class="flex items-center">
                          <div class="items-center w-full relative" v-if="!ingredient.edit">
                            <div class="intro-x">
                              <div class="box border px-5 mb-3 flex items-center">
                                <div class="ml-4 mr-auto">
                                  <div class="font-medium">{{ ingredient.text }}</div>
                                </div>
                                <button
                                  @click="editField('otherIngredients', ingredient, true)"
                                  type="button"
                                  class="btn-outline-dark btn-rounded btn-sm"
                                >
                                  <EditIcon class="btn-source-icon" />
                                </button>
                                <button
                                  @click="deleteField('otherIngredients', ingredient)"
                                  type="button"
                                  class="btn-outline-dark btn-rounded btn-sm"
                                >
                                  <Trash2Icon class="btn-source-icon" />
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="block w-full" v-else>
                            <div class="input-group w-full mb-3">
                              <input
                                id="crud-form-otherIngredients"
                                type="text"
                                name="otherIngredient"
                                class="form-control"
                                :placeholder="$t('views.productos.text19')"
                                aria-describedby="input-group-price"
                                v-model="ingredient.text"
                              />
                              <div
                                id="input-group-price"
                                class="input-group-text btn"
                                @click="editField('otherIngredients', ingredient, false)"
                              >
                                <SaveIcon />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('views.productos.text19')"
                          v-model="article.langs[lang_key].newOtherIngredient"
                          @keyup.enter="addField('otherIngredients', 'newOtherIngredient', $event)"
                        />
                        <div
                          id="input-group-add"
                          class="input-group-text btn"
                          @click="addField('otherIngredients', 'newOtherIngredient', { pointerId: true })"
                        >
                          <PlusIcon />
                        </div>
                      </div>
                      <div v-if="validations['otherIngredients']" class="text-theme-6 mt-2">
                        {{ $t("views.supplements.text95") }}
                      </div>
                    </div>
                    <!-- campo de politicas de devoluciones-->
                    <div class="w-full">
                      <div class="mt-4">
                        <label for="crud-form-13" class="form-label">{{ $t("views.productos.text28") }} </label>
                        <div class="input-group">
                          <textarea
                            id="crud-form-13"
                            type="text"
                            name="chart-tooltip"
                            class="form-control w-full"
                            :placeholder="$t('views.productos.text28')"
                            v-model="article.langs[lang_key].returnPolicies"
                            :key="lang_key"
                          />
                        </div>
                        <div v-if="validations[`article_${key}`]?.langs" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text95") }}
                        </div>
                      </div>
                    </div>

                    <!-- Botón para agregar más -->
                    <div class="mt-4">
                      <button @click="addArticulo" type="button" class="btn btn-primary" :disabled="!isFormComplete()">
                        {{ $t("views.productos.text31") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div v-if="validations.articles" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.text11") }}
                </div>
              </div>
              <!-- campo aprobado -->
              <div class="season mt-6">
                <label for="crud-form-3" class="form-label">
                  {{ $t("views.supplements.text94") }}
                </label>
                <div
                  class="mt-2 gap-4 gap-x-6 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 xl:gap-x-6 xxl:grid-cols-6"
                >
                  <div class="form-check mr-2 mt-2 sm:mt-0">
                    <input
                      id="checkbox-switch-not-review"
                      class="form-check-input"
                      type="radio"
                      name="status"
                      v-model="product.status"
                      value="1"
                    />
                    <label class="form-check-label" for="checkbox-switch-status">
                      {{ $t("views.supplements.UNREVIEWED") }}
                    </label>
                  </div>
                  <div class="form-check mr-2 mt-2 sm:mt-0">
                    <input
                      id="checkbox-switch-review"
                      class="form-check-input"
                      type="radio"
                      name="status"
                      v-model="product.status"
                      value="2"
                    />
                    <label class="form-check-label" for="checkbox-switch-status">
                      {{ $t("views.supplements.REVIEWED") }}
                    </label>
                  </div>
                </div>
                <div v-if="validations.status" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.text43") }}
                </div>
              </div>

              <!-- boton enviar -->
              <div class="text-right mt-5">
                <button v-on:click="saveProduct" type="button" class="btn btn-primary w-24">
                  <LoadingIcon v-if="loading" icon="three-dots" class="" />
                  <span v-else>{{ $t("views.save") }}</span>
                </button>
              </div>
            </div>
            <!-- END: Form Layout -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.test__facu {
  border: 2px solid red;
  /* height: 50px; */
  /* width: 100vw; */
}

.dark .accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  --tw-text-opacity: 1;
  color: #fff;
}

.mt-3 {
  color: #fff;
}

.modal-body .recomendacion-headline {
  display: none;
}

.modal-body ul:not(ul:first-of-type) {
  margin-left: 30px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.modal-body li {
  margin-top: 10px;
  margin-bottom: 10px;
}

.max-w-label {
  max-width: 90%;
}

.text-sm-14 {
  font-size: 0.875rem;
}

.btn-source-icon {
  width: 1rem;
}

.btn-source-icon.w-6 {
  width: 1.5rem;
}

.w-50 {
  width: 50%;
}

.my-custom-input {
  display: none !important;
}

.transparent {
  color: transparent;
}

.benefits_item:last-child .remove-item {
  visibility: hidden;
}

.benefits_item:nth-child(2) {
  margin-top: 0px;
}
</style>

<script>
import ProductsService from "../../../services/products.service";
import BrandsService from "../../../services/brands.service";
import FormatsService from "../../../services/formats.service";
import SupplementService from "@/services/supplements.service";
import Toastify from "toastify-js";

export default {
  setup() {},
  data() {
    return {
      validations: {
        brand: false,
        substance: false,
        substances: false,
        nameTicket: false,
        returnPolicies: false,
        perComponent: false,
        perServing: false,
        formats: false,
        natural_source: false,
        articles: false,
        status: false,
        value: false,
        certifications: false,
        labels: false,
        used: false,
        warning: false,
        currency: false,
      },
      loading: false,
      product: {
        brand: "",
        substance: "",
        articles: [
          {
            id: 0,
            substances: [],
            componentsGroups: "NONE",
            supplementFacts: {
              perServing: 0,
              perComponent: 0,
              supplyDays: 0,
            },
            components: [
              {
                componentActive: "",
                amountPerServing: 0,
                dv: 0,
              },
            ],
            format: "",
            naturalSource: "",
            langs: this.getLangsArticle(),
            certifications: [],
            labels: [],
            currency: "",
            stocks: [
              {
                stockA: 0,
                expirationDate: "",
                price: 0,
              },
            ],
          },
        ],
        status: "1",
      },
      activeLang: "lang__" + (localStorage.lang ? localStorage.lang : navigator.language.split("-")[0]),
      langs: this.$global.getLangs(),
      lang_key: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
      global_lang: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
      lang_inputs: [],
      getData: true,
      brands: [],
      formats: [],
      substances: [],
      certificationsProduct: [],
      labelsProduct: [],
      currencies: [],
      vueFillAprobed: false,
      typesComponents: this.$global.getComponentsGroups(),
      naturalSources: this.$global.getNaturalSource(),
      status: this.$global.getAspect(),
    };
  },
  watch: {
    "$i18n.locale": function (l) {
      this.getProduct();
    },
    activeLang: function () {
      this.lang_key = this.activeLang.replace("lang__", "");
    },
  },
  created() {
    this.verifiedAccess();
    this.getDataInitial();
    this.preparedLangs();
    this.getAllBrands();
    this.getAllSubstances();
    this.getAllFormats();
    this.getCertificationsProducts();
    this.getAllLabels();
    this.getAllCurrency();
  },
  methods: {
    verifiedAccess() {
      const permissions = localStorage.backoffice_permissions ? JSON.parse(localStorage.backoffice_permissions) : [];
      const approvedPermission = permissions.find((p) => p.name == "SUPPLEMENT_PRODUCT_ADMIN");
      if (approvedPermission) {
        this.vueFillAprobed = true;
      } else {
        this.vueFillAprobed = false;
      }
    },
    getDataInitial() {
      if (!localStorage.ProductItem) return;
      const localData = JSON.parse(localStorage.ProductItem);
      const newData = {};

      newData.id = localData.id ?? 0;
      newData.brand = localData.brand ?? "";
      newData.substance = localData.substance ?? "";
      newData.articles = localData.articles ?? [];
      newData.status = localData.status ?? "1";
      newData.langs = localData.langs ?? {};

      this.product = newData;
    },
    getLangsArticle() {
      const langs = this.langs ?? this.$global.getLangs();
      const dataByLang = {
        nameTicket: "",
        used: "",
        warning: "",
        returnPolicies: "",
        newOtherIngredient: "",
      };
      const objectLangs = langs
        .map((l) => l.key)
        .reduce(
          (x, y) => (
            (x[y] = Object.assign(
              {},
              {
                ...dataByLang,
                otherIngredients: [],
              }
            )),
            x
          ),
          {}
        );
      return objectLangs;
    },
    preparedLangs() {
      if (this.product.id && this.product.id != 0) return;

      // const dataByLang = {
      //   nameTicket: "",
      // }
      // this.product.articles[0].langs = this.langs.map(l => l.key).reduce((x, y) => (x[y] = dataByLang, x), {})
      // console.log("DATOS POR LENGUAJE: ", this.product);
      if (this.product.articles.length < 1) this.addArticulo();
    },
    getAllBrands() {
      BrandsService.getAllBrand()
        .then((response) => {
          this.brands = response.data ? response.data : response;
        })
        .catch(function (e) {
          this.loading = false;
        });
    },
    getAllSubstances() {
      this.substances = [];
      this.loading = false;
      // TEMPORAL NO AVAILABLE MOVED NUTRIHUB SERVICE
      // SupplementService.getAll().then((response) => {
      //   this.substances = (response.data) ? response.data : response
      // }).catch(function (e) {
      //   this.loading = false
      // })
    },
    getAllFormats() {
      FormatsService.getFormats()
        .then((response) => {
          this.formats = response.data ? response.data : response;
        })
        .catch(function (e) {
          this.loading = false;
        });
    },
    getCertificationsProducts() {
      var _this = this;
      ProductsService.getCertificationsProducts()
        .then((response) => {
          _this.certificationsProduct = response.data ? response.data : response;
        })
        .catch(function (e) {
          _this.loading = false;
        });
    },
    getAllLabels() {
      ProductsService.getLabels()
        .then((response) => {
          this.labelsProduct = response.data ? response.data : response;
        })
        .catch(function (e) {
          this.loading = false;
        });
    },
    getAllCurrency() {
      ProductsService.getCurrency()
        .then((response) => {
          this.currencies = response.data ? response.data : response;
        })
        .catch(function (e) {
          this.loading = false;
        });
    },
    isFormComplete() {
      if (this.product.articles.length < 1) return false;

      for (let i = 0; i <= this.product.articles.length; i++) {
        const article = this.product.articles[i];
        if (!article) continue;

        if (article.substances.length < 1) return false;
        // TODO: REALIZAR LA VALIDACION DE LOS DIFERENTES CAMPOS PARA CADA IDIOMA
        if (!article.supplementFacts.perServing) return false;
        if (!article.supplementFacts.perComponent) return false;
        if (!article.format) return false;
        if (!article.naturalSource) return false;
        if (article.certifications.length < 1) return false;
        if (article.labels.length < 1) return false;
        if (article.currency.length < 1) return false;
      }
      return true;
    },
    addArticulo() {
      const newArticle = {
        id: 0,
        substances: [],
        componentsGroups: "NONE",
        supplementFacts: {
          perServing: 0,
          perComponent: 0,
          supplyDays: 0,
        },
        components: [],
        format: "",
        natural_source: "",
        certifications: "",
        labels: "",
        currency: "",
        used: "",
        stocks: [],
        langs: {},
      };

      newArticle.langs = this.getLangsArticle();

      this.product.articles.push(newArticle);
    },
    removeArticulo(index) {
      if (this.product.articles.length > 1) {
        this.product.articles.splice(index, 1);
      }
    },
    addStock(articleIndex) {
      const article = this.product.articles[articleIndex];

      if (!article) {
        console.error(`No se encontró el artículo en el índice ${articleIndex}`);
        return;
      }

      // Inicializa stocks si no existe o no es un array
      if (!Array.isArray(article.stocks)) {
        this.$set(this.product.articles[articleIndex], "stocks", []);
      }

      // Agrega un nuevo stock
      article.stocks.push({
        stockA: 0,
        expirationDate: "",
        price: 0,
      });
    },
    removeStock(articleIndex, stockIndex) {
      const article = this.product.articles[articleIndex];
      article.stocks.splice(stockIndex, 1);
    },
    addComponent(articleIndex) {
      const article = this.product.articles[articleIndex];

      if (!article) {
        console.error(`No se encontró el artículo en el índice ${articleIndex}`);
        return;
      }

      // Inicializa componente si no existe o no es un array
      if (!Array.isArray(article.components)) {
        this.$set(this.product.articles[articleIndex], "components", []);
      }

      // Agrega un nuevo componente
      article.components.push({
        componentActive: "",
        amountPerServing: 0,
        dv: 0,
      });
    },
    removeComponent(articleIndex, componentIndex) {
      const article = this.product.articles[articleIndex];
      article.components.splice(componentIndex, 1);
    },
    supplyDays(article) {
      const perServing = parseFloat(article.supplementFacts.perServing) || 0;
      const perComponent = parseFloat(article.supplementFacts.perComponent) || 0;

      if (isNaN(perServing) || isNaN(perComponent)) {
        return;
      }
      article.supplementFacts.supplyDays = Math.round(perComponent / perServing);
    },
    calculatedComponentsGroups(index) {
      const article = this.product.articles[index];
      if (!article) return;

      const countSubstances = article.substances.length;

      if (countSubstances < 1) article.componentsGroups = "NONE";
      else if (countSubstances == 1) article.componentsGroups = this.typesComponents[0];
      else if (countSubstances < 10) article.componentsGroups = this.typesComponents[1];
      else article.componentsGroups = this.typesComponents[2];
    },
    addField(type, input, event) {
      const langKey = this.lang_key;
      const fieldAdd = this.product.articles[0].langs;

      // // Validar que el campo esté inicializado correctamente
      // if (!fieldAdd[langKey]) {
      //   this.$set(fieldAdd, langKey, { [type]: [], [input]: '' })
      // }

      const newInput = fieldAdd[langKey][input]?.trim();
      console.log("DATOS: ", newInput, langKey, type, input);
      console.log("DATOS DE LAN", fieldAdd);
      if (newInput && (event.key === "Enter" || event.pointerId || event.type === "focusout")) {
        fieldAdd[langKey][type].push({
          text: newInput,
          edit: false,
        });
        fieldAdd[langKey][input] = "";
      }
    },
    editField(type, ingredient, isEditing) {
      // Cambiar el estado de edición
      if (type === "otherIngredients") {
        ingredient.edit = isEditing;
      }
    },

    deleteField(type, ingredient) {
      const langKey = this.lang_key;

      // Filtrar el ingrediente que se quiere eliminar
      this.product.articles.forEach((article) => {
        article.langs[langKey][type] = article.langs[langKey][type].filter((item) => item !== ingredient);
      });
    },
    saveSuccessProduct() {
      Toastify({
        node: cash("#save-supplement-success").clone().removeClass("hidden")[0],
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "top",
        position: "right",
        stopOnFocus: true,
      }).showToast();
    },
    async saveProduct() {
      if (!this.validateProduct()) {
        console.error("El producto contiene errores de validación.");
        return;
      }

      this.loading = true;

      const existingProducts = JSON.parse(localStorage.getItem("products")) || [];

      if (!this.product.id) {
        // Asigna un nuevo ID único
        this.product.id = existingProducts.length + 1;
        existingProducts.push(this.product);
      } else {
        const index = existingProducts.findIndex((p) => p.id === this.product.id);
        if (index !== -1) {
          existingProducts[index] = this.product;
        } else {
          existingProducts.push(this.product);
        }
      }

      localStorage.setItem("products", JSON.stringify(existingProducts));

      this.loading = false;
      this.saveSuccessProduct();
      this.$router.push({ path: "/supplement-productos-list" });
    },

    // ---------------------
    getProduct: function () {
      var product = this.product;
      if (product.id) {
        Object.keys(this.lang_inputs).map(
          function (lang) {
            ProductsService.getProduct(product.id, lang).then((response) => {
              var product = response.data ? response.data : response;
              Object.keys(this.lang_inputs[lang]).map(
                function (key) {
                  this.lang_inputs[lang][key] = product[key];
                }.bind(this)
              );

              if (this.getData) {
                this.getData = false;
                this.product = response.data ? response.data : response;

                this.product.articles = this.product.articles.length > 0 ? this.product.articles : [""];
                this.product.status = product.status;
              }
            });
          }.bind(this)
        ); /*  this.getFormats() */
      }
    },
    getArticles() {
      ProductsService.getArticles()
        .then((response) => {
          this.product.articles = response.data ? response.data : response;
        })
        .catch((e) => {
          // this.loading = false
        });
    },
    validateProduct() {
      let hasError = false;

      // Validar la marca
      this.validations.brand = !this.product.brand || this.product.brand.trim() === "";
      if (this.validations.brand) {
        console.error("Error: La marca no está seleccionada o es inválida.");
        hasError = true;
      }

      // Validar la sustancia
      this.validations.substance = !this.product.substance || this.product.substance.trim() === "";
      if (this.validations.substance) {
        console.error("Error: La sustancia no está seleccionada o es inválida.");
        hasError = true;
      }

      // Validar cada artículo
      this.validations.articles = [];
      this.product.articles.forEach((article, index) => {
        const articleValidation = {
          substances: article.substances.length === 0,
          naturalSource: !article.naturalSource || article.naturalSource.trim() === "",
          format: !article.format || article.format.trim() === "",
          perServing: !article.supplementFacts.perServing || article.supplementFacts.perServing <= 0,
          perComponent: !article.supplementFacts.perComponent || article.supplementFacts.perComponent <= 0,
          supplyDays: !article.supplementFacts.supplyDays || article.supplementFacts.supplyDays <= 0,
          nameTicket: !Object.values(article.langs).every((lang) => lang.nameTicket && lang.nameTicket.trim() !== ""),
          returnPolicies: !Object.values(article.langs).every(
            (lang) => lang.returnPolicies && lang.returnPolicies.trim() !== ""
          ),
          used: !Object.values(article.langs).every((lang) => lang.used && lang.used.trim() !== ""),
          warning: !Object.values(article.langs).every((lang) => lang.warning && lang.warning.trim() !== ""),
          otherIngredients: article.langs[this.lang_key].otherIngredients.length === 0,
          certifications: article.certifications.length === 0,
          labels: article.labels.length === 0,
          currencies: article.currency.length === 0,
          stocks: article.stocks.map((stock) => ({
            stockA: stock.stockA <= 0,
            expirationDate: !stock.expirationDate || stock.expirationDate.trim() === "",
            price: stock.price <= 0,
          })),
        };

        // Agregar validaciones al índice correspondiente
        this.validations.articles[index] = articleValidation;

        // Validar stocks dentro del artículo
        articleValidation.stocks.forEach((stockValidation, stockIndex) => {
          if (stockValidation.stockA) {
            console.error(
              `Error en el artículo ${index + 1}, stock ${stockIndex + 1}: La cantidad de stock no es válida.`
            );
          }
          if (stockValidation.expirationDate) {
            console.error(
              `Error en el artículo ${index + 1}, stock ${stockIndex + 1}: La fecha de caducidad no es válida.`
            );
          }
          if (stockValidation.price) {
            console.error(`Error en el artículo ${index + 1}, stock ${stockIndex + 1}: El precio no es válido.`);
          }
        });
        if (
          Object.values(articleValidation).some((value) =>
            Array.isArray(value) ? value.some((v) => v.stockA || v.expirationDate || v.price) : value
          )
        ) {
          hasError = true;
        }
      });

      return !hasError;
    },
    isURLValid: function (url) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" +
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
          "((\\d{1,3}\\.){3}\\d{1,3}))" +
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
          "(\\?[;&a-z\\d%_.~+=-]*)?" +
          "(\\#[-a-z\\d_]*)?$",
        "i"
      );
      return !!pattern.test(url);
    },
    goSource(url) {
      window.open(url, "_blank");
    },
    changeLang(l) {
      this.activeLang = l;
    },
  },
};
</script>
<style>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  opacity: 0.2 !important;
  /* Firefox */
}
</style>
